import { Navigate } from "react-router";
import { live } from "@budgeter/shared";
import { useSnapshot, useSyncStatus } from "../data/StoreContext";
import { BudgetPage } from "./pages";
import { HomePage } from "../features/home/HomePage";
import { useLayoutMode } from "../layout/useLayoutMode";

/**
 * The app opens to Home on a phone (SPEC D12) and to the budget in the full app. A budget with
 * no accounts goes to onboarding — only once the local copy has loaded and a sync has happened,
 * so neither a cold start nor a new device is sent there by a momentarily empty snapshot.
 */
export function RootPage() {
  const mode = useLayoutMode();
  const snapshot = useSnapshot();
  const status = useSyncStatus();
  if (status.loaded && status.everSynced && live(snapshot, "accounts").length === 0) {
    return <Navigate to="/welcome" replace />;
  }
  return mode === "phone" ? <HomePage /> : <BudgetPage />;
}
